import { put } from "../../../../http";
import { SubscriptionItemType } from "../../../types";
import { subscriptionsBaseApiUrl } from "../../subscriptionsBaseUrl";

import { UpdateSubscriptionMutationRequest } from "./updateSubscription.types";
import { subscriptionItemToDraftDTO } from "../../utils";

export const updateSubscription = async (payload: UpdateSubscriptionMutationRequest) => {
  const { newSubscriptionItem, oldSubscriptionItem } = payload;
  const itemDraftDTO = subscriptionItemToDraftDTO(newSubscriptionItem);

  if (itemDraftDTO.subscriptionType === SubscriptionItemType.Slide) {
    await put(`${subscriptionsBaseApiUrl}/ReportsSubscription/${oldSubscriptionItem.id}`, itemDraftDTO);
  } else if (itemDraftDTO.subscriptionType === SubscriptionItemType.BulkExport) {
    await put(`${subscriptionsBaseApiUrl}/BulkExportSubscription/${oldSubscriptionItem.id}`, itemDraftDTO);
  } else if (itemDraftDTO.subscriptionType === SubscriptionItemType.SavedBulkExport) {
    await put(`${subscriptionsBaseApiUrl}/SavedBulkExportSubscription/${oldSubscriptionItem.id}`, itemDraftDTO);
  }
};
